import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Center, GlobalStyle } from "./styles/GlobalStyle";
import { ThemeProvider } from "styled-components";
import { theme } from "./styles/theme";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <ThemeProvider theme={theme}>
    <GlobalStyle />
    <Center>
      <App />
    </Center>
  </ThemeProvider>
);
